// extracted by mini-css-extract-plugin
export var changeIcon = "_67-4";
export var container = "_67-0";
export var divider = "_67-7";
export var externalLinkIcon = "_67-1";
export var green = "_67-5";
export var helpCircleIcon = "_67-3";
export var iconButton = "_67-2";
export var red = "_67-6";